import axios from "axios";
import {API_BASE_URL, BASE_URL} from "./consts";
import {Navigate} from "react-router-dom";

export const loginRequest = async (data) => {
	try {
		const config = {
			method: `POST`,
			url: `${API_BASE_URL}/gotoviy/login`,
			data,
			headers: {
				"Content-Type": "application/json",
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error during login:", error);
		throw error;
	}
};

export const postSerialsSehid = async (data) => {
	try {
		const config = {
			method: `POST`,
			url: `${BASE_URL}/api/serials`,
			data,
			headers: {
				"Content-Type": "application/json",
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error posting sehId:", error);
		throw error;
	}
};

export const verifyToken = async (data) => {
	const token = sessionStorage.getItem("token");

	try {
		const config = {
			method: `POST`,
			url: `${API_BASE_URL}/gotoviy/verify-token`,
			data: {token: data},
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error verifying token:", error);
		<Navigate to="/login" />;
		throw error;
	}
};
